import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ICountry } from "../../../Pages/Country/ICountry";

export const DeleteCountrySlice = createSlice({
  name: "DeleteCountry",
  initialState: {} as IReduxState<ICountry>,
  reducers: {
    deleteCountry: (state, _) => {
      state.isLoading = true;
    },
    successdeleteCountry: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failuredeleteCountry: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearDeleteCountryResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  deleteCountry,
  failuredeleteCountry,
  successdeleteCountry,
  clearDeleteCountryResponse,
} = DeleteCountrySlice.actions;

export default DeleteCountrySlice.reducer;
